import React, { useState } from "react";
import {
  getUserPofileAction,
  refrshAccessTokenAction,
} from "../Services/Store/Actions/AuthActions";
import { useDispatch } from "react-redux";
import { getUserFavoritesAction } from "../Services/Store/Actions/SpaceActions";

const useLoginCheck = () => {
  const dispatch = useDispatch();
  const [attemptCount, setAttemptCount] = useState(1);

  const isLoggedIn = async () => {
    const isLogin = await getUserPofileAction(dispatch);

    await getUserFavoritesAction(dispatch);

    console.log("attemptCount :", attemptCount, isLogin);

    if (
      attemptCount === 1 &&
      isLogin.status &&
      (isLogin.status === 401 || isLogin.status === 500)
    ) {
      console.log("getRefreshToken...");

      // Refresh authToken if expired
      const accessTokenRes = await refrshAccessTokenAction(dispatch);

      setAttemptCount((prev) => prev + 1);

      if (accessTokenRes.type === "success") {
        isLoggedIn();
      } else {
        console.log("Auth Failed");
      }
      // console.log("accessTokenRes :", accessTokenRes);
    }

    return isLogin;
  };

  return { isLoggedIn };
};

export default useLoginCheck;
